import { useLingui } from '@lingui/react';
import { useEffect } from 'react';
import { t } from '../../../locales/texts';
import usePulse from '../../hooks/usePulse';
import PaymentSection from './PaymentSection';
import PriceTag from './PriceTag';
import Onboarding from './Onboarding';

/**
 * Showing the sidebar when the ad has oped in for ship-it.
 *
 * The sidebar includes trade type, ad price (if any), price of ship-it,
 * ship-it buttons (bid and buy-now if possible), contact seller button
 * and also information about what the ship-it solution is all about.
 */
const FiksFerdig = () => {
    const { trackViewButton } = usePulse();
    const { i18n } = useLingui();

    useEffect(() => {
        trackViewButton();
    }, []);

    return (
        <section aria-label={i18n._(t.section.ariaLabel)}>
            <PriceTag />
            <PaymentSection />
            <Onboarding />
        </section>
    );
};

export default FiksFerdig;
